"use server";
import { revalidatePath } from "next/cache";
import { redirect } from "next/navigation";
import { forwardOnlineCommand } from "@/features/online-data/server/command";
import { getDatabase } from "@/server/db/client";
import { requireViewer } from "@/server/auth/current";
import { runAction } from "@/server/actions/result";
import { mutateProject } from "./service";
export async function projectAction(form: FormData) {
  const online = await forwardOnlineCommand("project", form);
  if (online) return online;
  return runAction(async () => {
    const viewer = await requireViewer(["partner"]);
    const input = Object.fromEntries(Array.from(form.entries()).filter((entry): entry is [string, string] => typeof entry[1] === "string"));
    const id = await mutateProject(getDatabase().db, viewer, input);
    revalidatePath("/partner", "layout");
    if (input.operation === "create" && id) redirect(`/partner/projects/${id}`);
  });
}
